module.exports = __webpack_public_path__ + "static/media/santa-2.dc353ba4.gif";